import React from 'react';
import { Button } from 'react-bootstrap';
import "../information&promo.css";


const Promo1 = () => {
  return (
    <div>
      <div
        className="promo-explanation  nunito fade-in2"
        style={{ color: "white" }}
      >
        <h2 className="roleway">PROMO SPESIAL SEPTEMBERKAH!</h2>
        <p>
          We Car Care merayakan bulan September dengan tawaran istimewa yang tak
          terlupakan! Rasakan keistimewaan Premium Detailing kami dengan harga
          istimewa:
        </p>

        <div className="promo-detail-list">
          <h3>🚗 Premium Detailing 🚗</h3>
          <ul>
            <li>Perawatan Kendaraan Terbaik yang Anda Dapatkan:</li>
            <li>
              Aspal Remover pada Bodi: Menghilangkan noda aspal dan kontaminan
              lainnya dari bodi kendaraan Anda.
            </li>
            <li>
              Membersihkan Jamur Kaca: Kaca kendaraan Anda akan bebas dari jamur
              dan noda yang mengganggu pandangan.
            </li>
            <li>
              Membersihkan Jamur Bodi: Menyegarkan tampilan bodi kendaraan
              dengan membersihkan jamur dan noda membandel.
            </li>
            <li>
              Compound Step 1: Proses kompound untuk menghilangkan goresan kecil
              dan memulihkan kilau asli kendaraan Anda.
            </li>
            <li>
              Polishing Step 2: Proses poles yang menghasilkan kilau tahan lama
              pada bodi kendaraan.
            </li>
            <li>
              Finishing Step 3: Tahap penyelesaian untuk menghasilkan tampilan
              yang luar biasa dan perlindungan ekstra.
            </li>
            <li>
              Membersihkan Kerak-karak Membandel: Kerak-kerak yang membandel
              akan dihilangkan secara profesional.
            </li>
            <li>
              Cleaning Interior: Membersihkan interior kendaraan dengan teliti.
            </li>
            <li>
              Cleaning Doortrim: Membersihkan trim pintu untuk tampilan yang
              bersih dan segar.
            </li>
            <li>
              Cleaning Dashboard: Interior kendaraan Anda akan bersinar dengan
              dashboard yang bersih.
            </li>
            <li>
              Cleaning Engine: Membersihkan mesin kendaraan Anda untuk performa
              yang optimal.
            </li>
            <li>
              Coating 2 Layer dengan Obat 9H: Lapisan pelindung tahan lama untuk
              perlindungan ekstra terhadap goresan dan elemen lingkungan.
            </li>
          </ul>
        </div>

        <p>
          HARGA NORMAL Rp2.500.000, SEKARANG hanya Rp2.000.000 selama bulan
          September. Estimasi pengerjaan dalam 1x24 jam.
        </p>

        <p>
          Ini adalah kesempatan istimewa untuk memberikan kendaraan Anda
          perawatan terbaik yang pantas Anda berikan. Jadwalkan perawatan Anda
          sekarang dan nikmati kilau dan perlindungan ekstra untuk kendaraan
          Anda.
        </p>

        <p>
          Promo Septemberkah ini tidak boleh dilewatkan! Hubungi kami sekarang
          juga!!!!!!
        </p>

        <p>Protect Your Vehicle Invesment With The Best Car Services</p>
        <Button
          variant="none"
          target="_blank"
          rel="noreferrer"
          className="price-card-button"
          href={
            "https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Promo%20Spesial%20September%20Berkah%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21"
          }
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};

export default Promo1;